export default {
  namespaced: true,
  state: {
    url: null,
    
  },
  mutations: {
    setUrl (state, value) {
      state.url = value
    },
  }
}
  